const NATIVE_SOURCE_KEY = 'saloone_native';
const NATIVE_PLATFORM_KEY = 'saloone_platform';
const CAPACITOR_SOURCE = 'capacitor';
const SUPPORTED_NATIVE_PLATFORMS = new Set(['ios', 'android']);

export const getNativePlatform = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const querySource = params.get(NATIVE_SOURCE_KEY);
    const queryPlatform = params.get(NATIVE_PLATFORM_KEY);
    const hasNativeQuery = params.has(NATIVE_SOURCE_KEY) || params.has(NATIVE_PLATFORM_KEY);

    if (hasNativeQuery) {
      if (
        querySource === CAPACITOR_SOURCE
        && SUPPORTED_NATIVE_PLATFORMS.has(queryPlatform)
      ) {
        window.localStorage.setItem(NATIVE_SOURCE_KEY, querySource);
        window.localStorage.setItem(NATIVE_PLATFORM_KEY, queryPlatform);
        return queryPlatform;
      }

      return '';
    }

    const storedSource = window.localStorage.getItem(NATIVE_SOURCE_KEY);
    const storedPlatform = window.localStorage.getItem(NATIVE_PLATFORM_KEY);

    if (
      storedSource === CAPACITOR_SOURCE
      && SUPPORTED_NATIVE_PLATFORMS.has(storedPlatform)
    ) {
      return storedPlatform;
    }
  } catch (error) {
    return '';
  }

  return '';
};

export const isNativeIosApp = () => getNativePlatform() === 'ios';

export const isProfessionalAcquisitionAllowed = () => !isNativeIosApp();
